export class Adresse {
    constructor(
        public id?: number,
        public adresse?: string,
        public adresse2?: string,
        public codePostal?: string,
        public ville?: string,
        public pays?: string,
        public departement?: string,
        public candidatureId?: number
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/adresse/adresse.model.ts